import React, {Component} from 'react';
import { compose, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Clear from '@material-ui/icons/Clear';
import Typography from '@material-ui/core/Typography';

import { toggleSaveEditPopup } from '../../redux/reducers/view';
import { resetPathToSaveVersion } from '../../redux/reducers/savedVersions';

import Popup from '../Popup';
import SaveEditForm from '../Form/SaveEditForm';

import { commonStyles } from '../../styles/styles';
import questions from '../../assets/questions-circular.svg';
import VersionNameField from '../Form/VersionNameField';
import { Field, reduxForm } from 'redux-form';
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';


class SaveEditPopup extends Component {
  state = {
    modal: true
  };

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
    this.props.resetPathToSaveVersion();
    this.props.toggleSaveEditPopup(false)
  }
  render() {
    return (
      <MDBContainer>
        <MDBModal isOpen={this.props.view.saveEditPopup} toggle={this.toggle}    >
          <MDBModalHeader className="secondary-color" toggle={this.toggle}>SAVE INSTANCE</MDBModalHeader>
          <form onSubmit={this.props.handleSubmit(this.props.handleSaveEdit)}>
          <MDBModalBody>
          Would you like to save this instance?
         
    {this.props.savedVersions.error && (
      <Typography className={classes.formError}>{this.props.savedVersions.error.message}</Typography>
    )}
    <Field name="versionName" component={VersionNameField} />
  
          </MDBModalBody>
          <MDBModalFooter>
          <MDBBtn
            color='success'

            type="submit"
            >
            SAVE
            </MDBBtn>
            {this.props.userProgramsFull.selectedUserVersion !== null && (
            <MDBBtn
              disabled={this.props.submitting}
              onClick={() => this.props.handleOverwrite()}
              color='secondary'
            >
              OVERWRITE
            </MDBBtn>
            )}
          </MDBModalFooter>
          </form>
        </MDBModal>
      </MDBContainer>
    );
  }
}


const styles = () => ({
  ...commonStyles,
  image: {
    width: 64,
    height: 64,
  },
});

const mapStateToProps = state => ({
  formState: state.form,
  savedVersions: state.savedVersionsReducer,
  userProgramsFull: state.userProgramsFullReducer,
  view: state.viewReducer
});
const mapDispatchToProps = dispatch => ({
  saveVersionRequest: () => dispatch(saveVersionRequest()),
  resetSaveEditForm: () => dispatch(resetSaveEditForm()),
  toggleSaveEditPopup: value => dispatch(toggleSaveEditPopup(value)),
  toggleNotification: value => dispatch(toggleNotification(value)),
  overwriteVersionRequest: () => dispatch(overwriteVersionRequest()),
  resetPathToSaveVersion: () => dispatch(resetPathToSaveVersion()),
});

export default compose(
  reduxForm({
    form: 'saveEdit',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    handleSaveEdit: props => values => {
      validateSaveEditPassword(values);
      props.saveVersionRequest();
    },
    handleOverwrite: props => () => {
      props.overwriteVersionRequest();
    },
    onClearClick: props => () => {
      const { resetPathToSaveVersion, toggleSaveEditPopup } = props;
      
      toggleSaveEditPopup(false);
    },
  }),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      const {
        toggleNotification,
        toggleSaveEditPopup,
        savedVersions,
        saveVersionRequest,
      } = nextProps;

      if (savedVersions.isVersionSaved) {
        toggleNotification({
          value: true,
          message: 'Version was saved successfully',
          type: 'success',
        });
        toggleSaveEditPopup(false);
        //saveVersionRequest();
      }
      if (savedVersions.isOverwriteVersion) {
        toggleNotification({
          value: true,
          message: 'Version was overwritten successfully',
          type: 'success',
        });
        toggleSaveEditPopup(false);
        //saveVersionRequest();
      }
    },
  }),
  withStyles(styles),
)(SaveEditPopup);

SaveEditPopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  savedVersions: PropTypes.instanceOf(Object),
  userProgramsFull: PropTypes.instanceOf(Object),
  handleOverwrite: PropTypes.func,
};




// WEBPACK FOOTER //
// ./src/Components/Popups/SaveEditPopup.jsx